module.exports = __webpack_public_path__ + "img/img5.9116f9b9.png";